import { render, staticRenderFns } from "./jsonMapperComponent.vue?vue&type=template&id=c4bc006a&scoped=true"
import script from "./jsonMapperComponent.vue?vue&type=script&lang=js"
export * from "./jsonMapperComponent.vue?vue&type=script&lang=js"
import style0 from "./jsonMapperComponent.vue?vue&type=style&index=0&id=c4bc006a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4bc006a",
  null
  
)

export default component.exports